import { DEFAULT_PAGES_CONFIGURATION } from 'services/default-pages-configuration.service';

export const ABPagesConfiguration = () => {
    return Object.assign({}, DEFAULT_PAGES_CONFIGURATION);
};
